import type { PartnerCityId, PricingPlanCategory } from '../../content';
import type { PlaceDetails } from './types';

export type MappedPlaceImport = {
  name: string;
  address: string;
  cityId: PartnerCityId;
  category: PricingPlanCategory | null;
  description: string;
  website: string;
  googlePlaceId: string;
  googleMapsUrl: string;
  importedPhotoUrls: string[];
  hours?: PlaceDetails['hours'];
};

/**
 * Maps resolved Place Details to wizard draft fields.
 * Backend should return the same shape from GET /v1/places/details.
 */
export function mapPlaceToBusinessImport(
  place: PlaceDetails,
  fallbackCityId: PartnerCityId = 'barcelona',
): MappedPlaceImport {
  return {
    name: place.name,
    address: place.formattedAddress,
    cityId: place.cityId ?? fallbackCityId,
    category: place.category,
    description: place.description ?? '',
    website: place.website ?? '',
    googlePlaceId: place.placeId,
    googleMapsUrl: place.mapsUrl,
    importedPhotoUrls: place.photoUrls,
    hours: place.hours,
  };
}
